<style lang="less">
@import '@/components/ai/zzl/zzl-ai-workbench.less';
.pdf-export {
  .markdown-body h1 {
    margin-top: 0 !important;
  }
}
</style>
<template>
  <div class="zzl-view-page" style="height:100%;overflow:hidden;position:relative;display:flex;flex-direction:column;min-height:0;">
    <div class="flex-wrap flex-between" style="flex-shrink:0;height:50px;padding:0 10px;background:linear-gradient(to right,#fff,var(--border));">
      <div class="flex-wrap split5" style="align-items:center;flex-wrap:wrap;gap:8px;">
        <div class="flex-wrap" style="white-space:nowrap;align-items:center;">
          平台
          <Select v-model="platform" style="margin-left:5px;width:120px;" @on-change="getProjectData()">
            <Option v-for="p in platforms" :key="p.key" :value="p.key">{{ p.name }}</Option>
          </Select>
        </div>
        <Select v-model="project_id" filterable style="width:300px" placeholder="选择项目" clearable @on-change="getProjectData()">
          <OptionGroup v-for="p in groupedProjects" :key="p.key" :label="p.name">
            <Option
              v-for="pr in p.projects"
              :key="pr.id"
              :value="pr.id"
              :label="pr.name"
            >
              {{ pr.name }}
              <Tag>{{ pr.finished ? '已完成' : '进行中' }}</Tag>
              <Tag>{{ pr.group }}</Tag>
            </Option>
          </OptionGroup>
        </Select>
        <Select v-model="type" style="width:140px" placeholder="选择类型" @on-change="getProjectData()">
          <Option v-for="p in types" :key="p.key" :value="p.key">{{ p.name }}</Option>
        </Select>
      </div>
      <div class="flex-wrap flex-right" style="gap:8px;">
        <Button class="zzl-view-top-refresh" type="default" @click="getProjects">刷新列表</Button>
        <Button @click="copyReportMd" v-if="!ai_executings && result">复制 Markdown</Button>
        <Button @click="CopyResult" v-if="!ai_executings && result">复制为 Word</Button>
        <Button @click="exportPDF" :disabled="!result">导出 PDF</Button>
      </div>
    </div>

    <div class="zzl-view-split" style="flex:1;min-height:0;border-top:1px solid var(--border);">
      <div class="zzl-view-left" style="padding:12px;display:flex;flex-direction:column;min-height:0;">
        <Spin v-if="loading" fix size="large">
          <div class="zzl-view-data-loading-text">加载数据中…</div>
        </Spin>
        <div class="zzl-view-left-half zzl-view-left-half--data">
          <div class="flex-wrap flex-between" style="align-items:center;margin-bottom:8px;flex-shrink:0;">
            <div class="zzl-view-section-title" style="margin:0;">数据下载和清理</div>
            <div class="flex-wrap" style="align-items:center;gap:8px;">
              <Button type="primary" icon="md-download" :disabled="!project_id" :loading="loading" @click="getProjectData">获取项目数据</Button>
              <Button type="warning" size="small" @click="CopyToClip">复制数据</Button>
            </div>
          </div>
          <div class="zzl-view-left-toolbar" style="margin-bottom:8px;flex-shrink:0;">
            <div class="flex-wrap" style="align-items:center;flex-wrap:wrap;gap:8px;">
              <Button v-if="images.length > 0 || files.length > 0" size="small" @click="CopyAttachmentsToClip">复制附件信息</Button>
              <span style="font-size:12px;color:var(--subtext2);">字符数 {{ aiText.length }}</span>
            </div>
          </div>
          <div class="zzl-view-left-track flex-wrap split5" style="margin-bottom:8px;align-items:center;flex-wrap:wrap;gap:8px;flex-shrink:0;">
            <span style="font-size:12px;color:#64748b;">时间范围</span>
            <template v-if="typeObj.rangeType == 'month'">
              <DatePicker type="month" v-model="dailyDate" placeholder="选择月份" @on-change="getProjectData" />
              <Select v-model="seasonYear" style="width:100px;" placeholder="年份" @on-change="getProjectData">
                <Option v-for="y in [moment().year()-2, moment().year()-1, moment().year(), moment().year()+1]" :key="y" :value="y">{{ y }}年</Option>
              </Select>
              <Select v-model="seasonQuarter" style="width:120px;" placeholder="季度" @on-change="getProjectData">
                <Option value="1">第1季度</Option>
                <Option value="2">第2季度</Option>
                <Option value="3">第3季度</Option>
                <Option value="4">第4季度</Option>
              </Select>
            </template>
            <template v-else-if="typeObj.rangeType == 'free'">
              <BaseDate v-model="freeDateStart" placeholder="起始日期" style="width:140px;margin-right:8px;" @on-change="getProjectData" />
              <BaseDate v-model="freeDateEnd" placeholder="截止日期" style="width:140px;" @on-change="getProjectData" />
            </template>
            <template v-else-if="typeObj.rangeType == 'season'">
              <Select v-model="seasonYear" style="width:100px;margin-right:8px;" placeholder="年份" @on-change="getProjectData">
                <Option v-for="y in [moment().year()-2, moment().year()-1, moment().year(), moment().year()+1]" :key="y" :value="y">{{ y }}年</Option>
              </Select>
              <Select v-model="seasonQuarter" style="width:80px;" placeholder="季度" @on-change="getProjectData">
                <Option value="1">第1季度</Option>
                <Option value="2">第2季度</Option>
                <Option value="3">第3季度</Option>
                <Option value="4">第4季度</Option>
              </Select>
            </template>
            <template v-else>
              <BaseDate v-model="dailyDate" placeholder="日报日期" @on-change="getProjectData" />
              <Button size="small" @click="dailyDate = yesterday_date; getProjectData()" v-if="moment(dailyDate).format('YYYY/MM/DD') != yesterday_date">昨天({{ yesterday_date }})</Button>
              <Button size="small" @click="dailyDate = dby_date; getProjectData()" v-if="moment(dailyDate).format('YYYY/MM/DD') != dby_date">前天({{ dby_date }})</Button>
            </template>
          </div>
          <div class="flex-wrap" style="margin-bottom:8px;align-items:center;gap:8px;">
            <i-switch v-model="extractForm" size="small" @on-change="cleanData" />
            <span style="font-size:12px;">提取表格</span>
            <i-switch v-model="onlyQuestion" size="small" @on-change="cleanData" />
            <span style="font-size:12px;">隐藏合规项</span>
          </div>
          <div class="zzl-view-left-textarea-wrap">
            <Input
              type="textarea"
              v-model="aiText"
              :rows="5"
              style="width:100%;flex:1;min-height:0;"
              placeholder="获取数据后显示任务数据"
            />
          </div>
        </div>
        <div class="zzl-view-left-half zzl-view-left-half--prompt">
          <div class="zzl-view-left-prompt-body">
            <AiPromptPanel
              v-model="userText"
              :mod="dailyPromptMod"
              :textarea-rows="4"
              :hide-mod-hint="true"
              split-head
            >
              <template slot="head-left">
                <div class="zzl-view-section-title flex-wrap" style="margin:0;align-items:baseline;gap:8px;">
                  提示词
                  <span style="font-size:12px;font-weight:400;color:var(--subtext2);">
                    （{{ labelForMod(dailyPromptMod) }} · {{ dailyPromptMod }}）
                  </span>
                </div>
              </template>
            </AiPromptPanel>
          </div>
        </div>
      </div>

      <div class="zzl-view-right" style="padding:10px;display:flex;flex-direction:column;min-height:0;">
        <div class="flex-wrap flex-between" style="align-items:center;margin-bottom:6px;">
          <div class="zzl-view-section-title" style="margin:0;">报告</div>
          <div class="zzl-view-right-actions flex-wrap" style="gap:8px;justify-content:flex-end;margin-left:auto;">
            <Button type="primary" icon="md-play" :loading="ai_executings" :disabled="aiText.length < 10" @click="CreateByAI">
              {{ ai_executings ? '生成中…' : (result ? '重新生成' : '生成报告') }}
            </Button>
            <Button v-if="images.length" @click="copyImageAddresses">复制图片地址</Button>
            <Button @click="copyReportMd" :disabled="!result">复制 Markdown</Button>
            <Button @click="exportPDF" :disabled="!result">导出 PDF</Button>
          </div>
        </div>
        <div class="zzl-view-right-report">
          <AiMarkdownStreamPanel
            ref="reportPanel"
            class="pdf-export"
            style="flex:1;min-height:0;"
            :value="result"
            :streaming="ai_executings"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
moment.locale('zh-cn');
import {extractAttachments, deepCleanTask, renderEFormMap} from '@/components/ai/clean';
import mixinPageState from '@/mixins/page_state';
import zzlAiStreamReport from '@/components/ai/zzl/mixins/zzlAiStreamReport';
import AiPromptPanel from '@/components/ai/AiPromptPanel.vue';
import AiMarkdownStreamPanel from '@/components/ai/AiMarkdownStreamPanel.vue';
import {labelForMod} from '@/components/ai/aiPromptModLabels';

export default {
  components: {AiPromptPanel, AiMarkdownStreamPanel},
  mixins: [mixinPageState, zzlAiStreamReport],
  data() {
    return {
      pageStateKey: 'ai_zzl_daily',
      pageStateFields: ['platform', 'project_id', 'type', 'dailyDate', 'freeDateStart', 'freeDateEnd', 'seasonYear', 'seasonQuarter', 'extractForm', 'onlyQuestion', 'userText'],
      seasonYear: moment().year(),
      seasonQuarter: (Math.floor((moment().month()) / 3) + 1).toString(),
      run: {},
      steps: [],
      messages: {},
      aiText: '',
      loading: false,
      task: {},
      type: '',
      images: [],
      freeDateStart: moment().startOf('month').format('YYYY-MM-DD HH:mm:ss'),
      freeDateEnd: moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
      platform: '',
      files: [],
      userText: '',
      yesterday_date: moment().subtract(1, 'days').format('YYYY/MM/DD'),
      dby_date: moment().subtract(2, 'days').format('YYYY/MM/DD'),
      dailyDate: moment().subtract(1, 'days').format('YYYY/MM/DD'),
      tracking_startDate: null,
      tracking_endDate: null,
      ai_executings: false,
      extractForm: false,
      onlyQuestion: false,
      result: '',
      tasks: [],
      task_id: '',
      projects: [],
      project_id: 'pid65054f01eabec',
      view: 'recent',
      prompt: {
        pmis: {
          daily: `根据任务数据，请帮我生成一份管理日报，要求内容完善，重点突出，基于上传数据不要发散，内容包括：项目名称，任务动态，前期工作情况，设计工作情况，招投标及合同情况，造价管理情况，机电安装配合情况，现场施工情况，其他事项，如果没有某类工作可以写无`,
          month: `根据某项目工作任务数据，请帮我生成一份项目建设简报，要求重点突出、条理清晰、语言精练，避免冗长和技术性过强的细节。基于上传数据不要发散，注意不要用表格展示！！！
为了增强可读性，请在描述的部分务必生成换行、编号形式（如：（1）（2）（3）），不要用·等符号区分。如有项目周报任务数据，需重点提炼汇总
项目建设简报内容分为三部分，具体如下：
一、项目进展情况，内容包括：
1、现场形象进度（如在施工阶段，描述形象进度；如不在施工阶段，参照如下描述：本周项目处于设计阶段，无现场施工活动），以下是示例：
（1）A塔楼核心筒机房层梁板支模及钢筋绑扎完成60%；主楼24层楼承板混凝土浇筑完成。
（2）B塔核心筒爬架拆除完成；主楼21层楼承板铺设及钢筋绑扎完成80%。
（3）A楼16~18层二次结构完成；B楼10～13层二次结构完成。
（4）A楼竖井风管20~25层安装完成100%，B楼13~18层安装完成100%；B楼冷凝水安装至20层。
2、前期管理情况，以下为示例：
（1）跟踪扩初纪要及区府专题纪要，因海绵办年径流量事宜，还未确定，等甲方协调后办理。
（2）环保系统办理环保备案登记。
（3）跟踪扩初方案调整进度，准备扩初方案规划审核，已征询供电、物业部门意见，环卫部门意见尚在跟踪中。
（4）联系规划关于区府纪要要求的临时道路规划报批，规划答复不用审核，产权单位同意即可。
（5）跟踪临时电进度，审图已完成、箱变租赁合同完成，根据甲方意见土建单位另行委托，送变电公司合同还在委托中（预算审核、合同审核过程中）。和供电客服沟通通电时间。
3、技术管理工作，以下为示例：
（1）跟踪勘察报告出具，10月6日联系勘察先把勘察平面、剖面图给设计；10月11日提供详勘报告电子稿；联系勘察抗浮水位按设计建议调整及详勘报告有关项目概况按最新建筑图调整，10月25日提供送审图版文本3本。
（2）跟踪桩基方案比较，业主明确桩基先行并确定采用钻孔灌注桩，业主桩基预审承诺书请住建局盖章并上传审图网。
（3）跟踪地理信息中心面积初核，10月11日图纸发地理信息中心，10月14日提供初核结果，跟踪协调设计院分析面积差异并对建筑图调整。
（4）跟踪节能评估，市院要到施工图中后期约11月中旬左右提供齐补充资料，等全部资料提供后约2周可以完成。
（5）跟踪基坑围护方案设计，目前条件还不太具备，10月22日先提供了水土保持编制需要的围护方案，建议做两个方案供比选。
4、合约管理工作，以下是示例：
（1）土方外运及临时道路合同出具审核意见。
（2）景观绿化及办公楼精装修设计方案征集及施工图设计报价竞争性谈判文件出具审核意见。
（3）全过程工程咨询合同签订完成。
（4）临时电租赁合同及三方协议签订完成。
（5）总包范围的初步策划。
（6）出具主设计合同审核意见。
5、合同签订、费用支付情况（若没有，填“无”，若有，明确合同名称及支付情况），以下是示例：
（1）本月签订合同3份，包括：《全过程工程咨询合同》、《临时用电设备箱式变租赁合同》、《临时用电设备箱式变租赁服务三方协议》。
（2）本月费用支付情况：本月发生无合同支付1笔0.055万元，其中非住宅不动产登记费0.055万元；本月发生合同支付/万元；
注：以上费用支付统计按支付证书出具时间（即费用支付）时间统计。
6、现场管理工作，以下是示例：
（1）东北角红线范围内管井移位。管井移位经各方协调由海曙开投联系相关单位进行封堵并承担费用，因节前工人返乡及春节后新冠肺炎疫情影响，至今未完成。
（2）东北次出入口。2019年12月27日联系了海曙开投、区旧村办、南站指挥部、南门街道、中建三局等相关单位在海曙旧村办会议室组织了专题协调会，相关单位原约定1月10日完成由中建三局完成道口重新开设，实际未完成。因场地封闭需要，我方已将东北角道口内退进行了临时封闭。
（3）临时便道与临时场地租用。地块西侧临设办公区完成85%，临设生活区地坪硬化完成，待测量工作完成后，近期与旧村办签订租地协议。
二、下月工作计划，内容主要结合下午工作任务信息及本月未完工作任务描述下月的工作计划，列出下月计划开展的关键工作和目标，计划达到的里程碑或完成的重点任务，注意分别描述前期管理工作、技术管理工作、合同管理工作、现场管理工作等4个方面的重点工作。以下是示例：
1、前期管理工作
（1）跟踪临时场地租赁和临时通道手续
（2）完成水土保持评估及备案。
（3）联系规划方案公示及规划放样工作。
2、技术管理工作
（1）跟踪基坑围护设计
（2）跟踪主体施工图设计
（3）跟踪主体施工图审查
3、合同管理工作
（1）协助业主完成地基基础检测招标
（2）跟踪水保、节能、指标复核成果出具后费用支付
4、现场管理工作
（1）跟踪临设搭设、临时围挡及临时道路施工
（2）春节前现场防火防盗专项检查
三、近期需建设单位协调解决及重点关注事项，清晰列出需要建设单位出面协调、审批、决策或提供支持的具体事项，内容注意去除本月明确已解决或根据任务数据内容可推断已解决的事项。以下是示例：
（1）海绵城市年径流量指标按照新导则2019甬DX-08《宁波市海绵城市规划设计导则》进行调整，区规划局已初步同意，但区住建局需进一步沟通，节能评估目前仍按80%年径流量申报，需持续关注。
（2）通信基站配建事宜，需建设单位进一步与通管局、铁塔公司沟通协调。
（3）三网通信接入事宜，请建设单位关注需求。
====以下是工作任务数据===
`,
          season: `根据任务数据，请帮我生成一份管理季报，要求内容完善，重点突出，基于上传数据不要发散，内容包括：项目名称，任务动态，前期工作情况，设计工作情况，招投标及合同情况，造价管理情况，机电安装配合情况，现场施工情况，其他事项，如果没有某类工作可以写无`,
          free: '根据任务数据，请帮我生成一份管理报告，要求内容完善，重点突出，基于上传数据不要发散，内容包括：项目名称，任务动态，前期工作情况，设计工作情况，招投标及合同情况，造价管理情况，机电安装配合情况，现场施工情况，其他事项，如果没有某类工作可以写无',
        },
        jlis: {
          daily: `根据任务数据，请帮我生成一份监理日报，要求内容完善，重点突出。基于上传数据不要发散。监理日报内容包括：
1、项目名称（不含天气）
2、施工情况（描述当日现场施工内容）；
3、施工现场材料设备构配件进场及见证取样情况（描述施工现场材料进场监理验收情况，以及混凝土试块、施工试件、需复试原材料等见证取样送检等情况）；
4、施工现场机械进场及运行情况（描述现场机械动态情况，若无相关动态更新内容，填“正常”）；
5、监理工作内容及问题处理情况（简述监理人员当日开展的监理工作，重点是质量控制和安全监理工作及发现问题的处理情况，会议组织，函件签发等等情况，如没有，可忽略）；
6、其他有关事项（外部检查，进度造价，设计变更，风险预警等等，如没有，可忽略）。
7、总监理工程师签字和报告日期收尾`,
          month: `监理月报内容分为五部分，具体如下：
第一部分为本月工程实施情况，内容包括：
1、至当月底工程形象进度情况；
2、工程质量情况总体评价，简要描述，举例：本月工程质量整体可控，主体结构、钢筋工程及砼浇筑施工存在部分问题，整改后能满足设计及规范要求。）；
3、安全文明施工情况总体评价，简要描述（本月未发生安全生产事故，施工机械正常运行，总体情况可控）
第二部分为本月监理工作情况，内容包括：
1、本月监理主要工作，描述本月除质量控制、进度控制、造价控制外的主要监理工作，列项描述，比如：监理实施细则编制，监理例会组织，施工方方案审查，监理工作交底等等；
2、工程质量控制情况：描述本月旁站监理、隐蔽验收、见证取样、巡视检查等监理质量控制方面工作，以下为示例：
（1）钢筋原材料：对进场钢筋原材料进行验收并现场见证取样，本月共验收钢筋原材2批次，见证取样复试10组，复试结果均合格。
（2）机械连接试件：对现场各部位机械连接试件进行见证取样复试，本月共见证取样钢筋机械连接16批次，见证取样检测83组，检测结果均合格。
（3）商品混凝土：现场共见证取样C50P6混凝土标养试件12组、同条件5组，抗渗3组，C35P6混凝土标样试块35组、同条件6组、拆模6组、抗渗7组，C30P6混凝土标样试块2组、抗渗1组，除龄期未到报告待出外，已出报告均合格。
（4）混凝土浇筑、防水卷材、土方回填、PC吊装施工旁站监理。对地下室底板、外墙、顶板施工进行旁站监理，主要控制混凝土标号强度、振捣间距、时间及混凝土完成面高度等，并做好相应的旁站监理记录。对梁柱节点、梁板柱钢筋加工、制作、绑扎安装进行检查，发现问题及时要求施工单位进行整改。
3、工程进度控制情况: 描述本月监理单位审查审批监理进度计划、检查进度偏差与提出监理纠偏意见、提醒施工单位关注材料采购与施工准备、总分包工作衔接、签发进度相关函件，以及其他与进度控制相关的监理工作，以下为示例：
（1）审查施工单位提交的调整后总进度计划和标准层施工进度计划。
（2）检查和督促施工单位实施进度计划，并根据实际施工进展，提出相应的调整（赶工）意见。
（3）督促施工单位及时落实装修、安装、智能化等三选一定牌材料选样工作。
（4）要求施工单位做好二次结构班组选择、施工单位电梯安装等准备工作。

4、造价控制情况：描述本月监理单位在工程款支付审核、现场工程签证方面的工作，以下为示例：
（1）工程款支付申请审核：本月审核支付9月工程进度款。
（2）现场签证：本月1次，累计6次。签证内容为：桩基施工遇地下障碍物（废弃化粪池），施工单位按要求进行破除清理
5、信息、合同管理及工程协调情况，以下为示例：
（1）及时记录监理日志，编写监理周报、月报。
（2）日常的监理资料及时整理、归档。
第三部分为本月安全文明施工的监理工作内容，内容包括：
统计监理监理人员当月安全周检、安全巡查、安全验收、安全旁站监理、危大工程巡视、节前检查、发现的问题督促整改方面的工作内容及相关数据，以下是示例：
（1）本月共组织安全周检3次，节前安全检查1次，形成相关检查记录。
（2）督促施工单位对安全文明施工周检中发现的问题抓紧整改回复。
（3）督促施工单位做好新进场班组工人的三级教育及安全技术交底工作。
（4）落实日常安全巡查，并对检查发现的问题督促施工单位整改和进行复查。
（5）检查现场深基坑、起重机械、临时用电、临边围护、高处作业、工人安全帽、安全带等防护措施到位情况，发现问题及时通知施工单位整改。
（6）对基坑支撑拆除进行专项检查，发现的问题通知施工单位进行处理。
（7）旁站监理3台塔吊的定期维保。
第四部分为本月施工中存在的问题及处理情况，内容包括：
1、安全文明施工方面，内容包括：一句话简述上个月发现的安全文明施工问题施工单位整改落实情况，具体描述本月施工过程中主要存在的安全文明施工问题（重点是危大工程及高风险作业方面施工单位已整改落实的问题，不超过8条问题），以及对发现的安全文明施工问题施工单位的整改落实情况，以下是示例：
上月发现的安全文明施工问题施工方已整改落实，本月通过日常巡查、联合周检、安全验收发现以下问题：
（1）1#、2#研究生公寓楼外架连墙件跟进缓慢，一层抱住未设置，楼层间硬隔离设置不到位。
（2）公寓楼外架临边防护、脚手片设置不到位。
（3）钢筋班组人员柱钢筋绑扎高处作业安全带穿戴不到位。
上述问题经监理单位指出后，第1条尚在整改中，其余已整改完成。
2、施工质量方面，内容包括：一句话简述上个月发现的施工质量问题施工单位整改落实情况，具体描述本月施工过程中主要存在的施工质量问题（重点是施工单位已整改落实的问题，不超过8条问题），以及对发现的施工质量问题施工单位的整改落实情况，以下是示例：
上月发现的安全文明施工问题施工方已整改落实，本月通过日常巡查、联合周检、安全验收发现以下问题：
（1）柱底模板封堵不到位，砼成型蜂窝麻面情况较普遍。
（2）梁板钢筋存在漏设情况。
（3）钢筋套丝端头不平整，钢筋套筒连接外露丝扣长度不符合规范要求。
上述问题经监理单位指出后，第2条尚在整改中，其余已整改完成。
3、资料方面，主要描述本月施工资料报验是否正常。若不正常，描述具体问题。
第五部分下月监理工作重点，内容涵盖两方面，包括：
一方面是常规监理工作，比如特种作业人员核查、原材料进场验收、安全隐患排查与督促整改、进度计划审查审批、施工过程中碰到的问题协调、组织监理例会、协助建设单位工作等，另一方面结合本月监理工作内容及未完工作任务描述下月的施工阶段，监理方在质量控制、安全管理、进度控制、工程协调方面的重点工作。以下是示例：
下月现场主要施工内容是上部结构施工，二次结构开始施工，监理工作重点是：
（1）检查总包及分包单位现场管理人员到位情况，督促施工单位管理人员履职到位；
（2）做好原材料（下期重点幕墙龙骨、幕墙玻璃、GRC、安装管道及配件、屋面保温板、防水涂料、防水卷材、保温砂浆、抗裂砂浆、防霉涂料等）的进场检查及验收工作，审查合格证等质保资料，按要求进行见证取样和送检，同时不定期进行平行检测；
（3）按规范要求见证上述第2条中的各种原材料的取样和见证工作；
（4）对各施工工序做到每天巡视检查，发现问题及时要求施工单位整改；对隐蔽验收、技术复核等关键环节进行全数检查，对影响较大的问题，签发监理通知单； 
（5）审查特种作业人员上岗证，同时不定期检查现场特种作业人员是否人证相符（重点审查吊篮安拆工、起重机械安拆工、电工、焊工等）；
（6）下阶段现场主要危险源包括：起重机械、临边洞口防护、临时用电、外架等。每天对现场安全文明施工情况进行检查，发现各类安全隐患和不文明施工情况，及时通报施工单位要求整改，对隐患较大的，及时签发电子整改单位或监理通知单；持续做好落实好安全联合周检、安全隐患排查、文明施工等内容的专项检查和验收；
（7）审查施工单位上报的周、月及阶段性进度计划，并经常性的对实际进度与计划进度相比较，如滞后，分析原因，提出监理意见和建议，要求施工单位及时采取必要的赶工措施，确保工程顺利推进。
（8）做好投资控制，及时审查工程变更、施工进度款（民工工资款），签署相关文件，建立产值和支付台账；
（9）对施工过程中碰到的需要各方协调的问题，及时与业主、设计及施工单位进行沟通。召开工地例会，协调现场施工过程中出现的管理和技术问题，形成会议纪要，及时形成会议纪要并发放到相关各单位。
（10）积极协助、落实建设单位提出的其它各项工作。
`,
          season: `根据任务数据，请帮我生成一份监理季度报告，要求内容完善，重点突出。基于上传数据不要发散。监理季度报告内容包括：
1、项目名称（不含天气）
2、施工情况（描述当月现场施工内容）；
3、施工现场材料设备构配件进场及见证取样情况（描述施工现场材料进场监理验收情况，以及混凝土试块、施工试件、需复试原材料等见证取样送检等情况）；
4、施工现场机械进场及运行情况（描述现场机械动态情况，若无相关动态更新内容，填“正常”）；
5、监理工作内容及问题处理情况（简述监理人员当日开展的监理工作，重点是质量控制和安全监理工作及发现问题的处理情况，会议组织，函件签发等等情况，如没有，可忽略）；
6、其他有关事项（外部检查，进度造价，设计变更，风险预警等等，如没有，可忽略）。
`,
          free: '根据任务数据，请帮我生成一份监理报告，要求内容完善，重点突出。基于上传数据不要发散。监理报告内容包括：',
        },
        jgis: {
          daily: `根据任务数据，请帮我生成一份监管日报，要求内容完善，重点突出。基于上传数据不要发散。监管日报内容包括：`,
          month: `根据任务数据，请帮我生成一份监管月报，要求内容完善，重点突出。基于上传数据不要发散。监管月报内容包括：`,
          season: `根据任务数据，请帮我生成一份监管季度报告，要求内容完善，重点突出。基于上传数据不要发散。监管季度报告内容包括：`,
          free: '根据任务数据，请帮我生成一份监管报告，要求内容完善，重点突出。基于上传数据不要发散。监管报告内容包括：',
        },
      },
      types: [{
        name: '日报',
        key: 'daily',
        rangeType: 'day',
      }, {name: '月报',
        key: 'month',
        rangeType: 'month',
      },

      {name: '季度',
        key: 'season',
        rangeType: 'season',
      }, {
        name: '时间段',
        key: 'free',
        rangeType: 'free',
      },
      ],
    };
  },

  mounted() {
    this.$api.afterLogin(()=>{
      this.getProjects();
    });
  },

  computed: {
    /** 按平台 + 报表类型区分提示词库（日报/月报/季报/时间段） */
    dailyPromptMod() {
      const plat = (this.platform && String(this.platform).trim()) || 'pmis';
      const typ = (this.type && String(this.type).trim()) || 'daily';
      return `zzl-daily-${plat}-${typ}`;
    },
    typeObj() {
      return this.types.find((t)=>t.key == this.type) || {};
    },
    platforms() {
      return [{
        key: 'pmis',
        name: '项管',
      }, {
        key: 'jlis',
        name: '监理',
      }, {
        key: 'jgis',
        name: '监管',
      }];
    },
    groupedProjects() {
      const groupmap = {};
      this.projects.filter((p)=>p.platform && p.platform.split(',').includes(this.platform)).forEach((p)=>{
        const group = p.group || '未分组';
        if (!groupmap[group]) {
          groupmap[group] = [];
        }
        groupmap[group].push(p);
      });
      return Object.keys(groupmap).map((g)=>{
        return {
          key: g,
          name: g,
          projects: groupmap[g],
        };
      });
    },
  },
  methods: {
    labelForMod,
    CopyResult() {
      // 复制为 Word 友好的格式
      if (!this.result) {
        this.$Message.warning('没有可复制的内容');
        return;
      }

      try {
        // 获取渲染后的 HTML 内容
        let htmlContent = '';
        const contentRef = this.$refs.reportPanel;
        const el = contentRef && contentRef.getPdfElement ? contentRef.getPdfElement() : null;
        if (el) {
          htmlContent = el.innerHTML;
        } else {
          // 如果没有渲染内容，使用 markdown 文本
          htmlContent = this.result;
        }

        // 转换为 Word 友好的 HTML 格式
        const wordHtml = this.convertToWordHtml(htmlContent);

        // 使用 Clipboard API 复制 HTML 格式
        if (navigator.clipboard && navigator.clipboard.write) {
          const htmlBlob = new Blob([wordHtml], {type: 'text/html'});
          const textBlob = new Blob([this.getPlainText(htmlContent)], {type: 'text/plain'});

          const clipboardItem = new ClipboardItem({
            'text/html': htmlBlob,
            'text/plain': textBlob,
          });

          navigator.clipboard.write([clipboardItem]).then(() => {
            this.$Message.success('复制成功（Word 格式）');
          }).catch((err) => {
            console.error('复制失败:', err);
            // Fallback: 使用传统方法
            this.fallbackCopyHtml(wordHtml);
          });
        } else {
          // Fallback: 使用传统方法
          this.fallbackCopyHtml(wordHtml);
        }
      } catch (error) {
        console.error('复制失败:', error);
        this.$Message.error('复制失败');
      }
    },

    // 转换为 Word 友好的 HTML 格式
    convertToWordHtml(htmlContent) {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = htmlContent;

      // 清理和转换 HTML，使其符合 Word 格式要求
      const processElement = (element) => {
        // 处理标题 - Word 需要明确的样式
        const headings = element.querySelectorAll('h1, h2, h3, h4, h5, h6');
        headings.forEach((heading) => {
          const level = parseInt(heading.tagName.charAt(1));
          heading.setAttribute('style', `font-weight: bold; font-size: ${24 - level * 2}pt; margin-top: 12pt; margin-bottom: 6pt;`);
        });

        // 处理段落
        const paragraphs = element.querySelectorAll('p');
        paragraphs.forEach((p) => {
          if (!p.getAttribute('style')) {
            p.setAttribute('style', 'margin: 6pt 0;');
          }
        });

        // 处理粗体
        const strongElements = element.querySelectorAll('strong, b');
        strongElements.forEach((strong) => {
          strong.setAttribute('style', 'font-weight: bold;');
        });

        // 处理斜体
        const emElements = element.querySelectorAll('em, i');
        emElements.forEach((em) => {
          em.setAttribute('style', 'font-style: italic;');
        });

        // 处理列表
        const lists = element.querySelectorAll('ul, ol');
        lists.forEach((list) => {
          list.setAttribute('style', 'margin-left: 20pt; padding-left: 20pt;');
        });

        // 处理列表项
        const listItems = element.querySelectorAll('li');
        listItems.forEach((li) => {
          if (!li.getAttribute('style')) {
            li.setAttribute('style', 'margin: 3pt 0;');
          }
        });

        // 处理代码块 - Word 需要特殊处理
        const codeBlocks = element.querySelectorAll('pre code, pre');
        codeBlocks.forEach((code) => {
          code.setAttribute('style', 'font-family: "Courier New", monospace; background-color: #f5f5f5; padding: 6pt; border: 1px solid #ddd; display: block; white-space: pre-wrap;');
        });

        // 处理行内代码
        const inlineCodes = element.querySelectorAll('code:not(pre code)');
        inlineCodes.forEach((code) => {
          code.setAttribute('style', 'font-family: "Courier New", monospace; background-color: #f5f5f5; padding: 2pt 4pt;');
        });

        // 处理链接
        const links = element.querySelectorAll('a');
        links.forEach((link) => {
          const href = link.getAttribute('href');
          if (href) {
            link.setAttribute('style', 'color: #0066cc; text-decoration: underline;');
          }
        });

        // 处理表格
        const tables = element.querySelectorAll('table');
        tables.forEach((table) => {
          table.setAttribute('style', 'border-collapse: collapse; width: 100%; margin: 6pt 0;');
          const cells = table.querySelectorAll('td, th');
          cells.forEach((cell) => {
            cell.setAttribute('style', 'border: 1px solid #ddd; padding: 4pt;');
          });
        });

        // 处理引用块
        const blockquotes = element.querySelectorAll('blockquote');
        blockquotes.forEach((blockquote) => {
          blockquote.setAttribute('style', 'border-left: 4px solid #ddd; padding-left: 12pt; margin: 6pt 0; color: #666;');
        });

        // 移除可能不兼容的样式类
        const allElements = element.querySelectorAll('*');
        allElements.forEach((el) => {
          // 保留 style 属性，但移除 class（Word 可能不支持）
          // el.removeAttribute('class');
        });
      };

      processElement(tempDiv);

      // 生成 Word 友好的 HTML（使用标准 HTML 格式，Word 可以识别）
      const wordHtml = `<!DOCTYPE html>
<html>
<head>
<meta charset="UTF-8">
<meta name="Generator" content="Microsoft Word">
</head>
<body>
${tempDiv.innerHTML}
</body>
</html>`;

      return wordHtml;
    },

    // 从 HTML 中提取纯文本
    getPlainText(htmlContent) {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = htmlContent;
      return tempDiv.textContent || tempDiv.innerText || '';
    },

    // Fallback 方法：使用传统方式复制
    fallbackCopyHtml(htmlContent) {
      // 从完整 HTML 中提取 body 内容
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlContent, 'text/html');
      const bodyContent = doc.body ? doc.body.innerHTML : htmlContent;

      const tempDiv = document.createElement('div');
      tempDiv.style.position = 'fixed';
      tempDiv.style.left = '-9999px';
      tempDiv.style.top = '-9999px';
      tempDiv.innerHTML = bodyContent;
      document.body.appendChild(tempDiv);

      const range = document.createRange();
      range.selectNodeContents(tempDiv);
      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);

      try {
        document.execCommand('copy');
        this.$Message.success('复制成功（Word 格式）');
      } catch (err) {
        console.error('复制失败:', err);
        this.$Message.error('复制失败，请手动复制');
      } finally {
        selection.removeAllRanges();
        document.body.removeChild(tempDiv);
      }
    },
    getProjects() {
      this.$api.get('logined_zzl/projects?q=all').then((res)=>{
        this.projects = res.data.data;
        // 只有在没有恢复的 project_id 或恢复的 project_id 不存在时才设置默认值
        if (this.projects.length > 0) {
          const savedProjectId = this.project_id;
          const projectExists = savedProjectId && this.projects.find((p) => p.id === savedProjectId);
          if (!projectExists) {
            this.project_id = this.projects[0].id;
          }

          this.__initPageState();
          // 项目列表加载完成后，如果有有效的 project_id，获取项目数据
          if (this.project_id) {

          }
        }
      });
    },
    zzlReportPdfStem() {
      const project = this.projects.find((p) => p.id == this.project_id);
      const name = project ? project.name.replace(/[/\\?%*:|"<>]/g, '_') : 'daily';
      return `${name}_${this.platform}_${this.type}_${moment().format('YYYYMMDD')}`;
    },
    freeRangeStartMoment() {
      return this.freeDateStart && moment(this.freeDateStart).isValid() ? moment(this.freeDateStart) : moment().startOf('month');
    },
    freeRangeEndMoment() {
      return this.freeDateEnd && moment(this.freeDateEnd).isValid() ? moment(this.freeDateEnd) : moment().endOf('day');
    },
    getProjectData() {
      this.loading = true;
      let date = moment(this.dailyDate).format('YYYY-MM-DD');
      if (this.typeObj.rangeType == 'free') {
        date = [this.freeRangeStartMoment(), this.freeRangeEndMoment()].map((m)=>m.format('YYYY-MM-DD')).join(',');
      } else if (this.typeObj.rangeType == 'season') {
        date = moment(`${this.seasonYear}-${((this.seasonQuarter-1)*3+1)}`, 'YYYY-M').startOf('month').format('YYYY-MM-DD');
      }

      const prompt = this.prompt[this.platform][this.type] || '';

      this.$api.get(`logined_zzl/daily_data?type=${this.platform}&range=${this.typeObj.rangeType}&pid=${this.project_id}&date=${date}`).then((res)=>{
        this.tasks = res.data.data;
        const project = this.projects.find((p)=>p.id == this.project_id);
        const type = this.types.find((t)=>t.key == this.type);
        if (type.rangeType == 'month') {
          const time = moment(this.dailyDate).format('YYYY/MM');
          this.userText = `${prompt};以下是项目${project.name}的在${time}的月报任务数据`;
        } else if (type.rangeType == 'free') {
          const s = this.freeRangeStartMoment();
          const e = this.freeRangeEndMoment();
          const time = `${s.format('YYYY/MM/DD')},${e.format('YYYY/MM/DD')}`;
          this.userText = `${prompt};以下是项目${project.name}的在${time}的任务数据`;
        } else if (type.rangeType == 'season') {
          const time = moment(`${this.seasonYear}-${((this.seasonQuarter-1)*3+1)}`, 'YYYY-M').startOf('month').format('YYYY/MM');
          this.userText = `${prompt};以下是项目${project.name}的在${time}的季度任务数据`;
        } else {
          const time = moment(this.dailyDate).format('YYYY/MM/DD');
          this.userText = `${prompt};以下是项目${project.name}的在${time}日报任务数据`;
        }

        this.cleanData();
      }).finally(()=>{
        this.loading = false;
      });
    },
    cleanData() {
      let range = this.typeObj.rangeType;
      let date = this.dailyDate;
      if (range == 'season') {
        range = 'quarter';
        date = moment(`${this.seasonYear}-${((this.seasonQuarter-1)*3+1)}`, 'YYYY-M').startOf('month').format('YYYY-MM-DD');
      }

      let started_at = moment(date).startOf(range);
      let end_at = moment(date).endOf(range);
      if (range == 'free') {
        started_at = this.freeRangeStartMoment().startOf('day');
        end_at = this.freeRangeEndMoment().endOf('day');
      }
      const eformmap = {};
      this.cleaned = this.tasks.map((t)=>deepCleanTask(t, started_at, end_at, null, this.extractForm?eformmap:null, this.onlyQuestion, true)).join('\n');
      const {text, images, files} = extractAttachments(this.cleaned);
      const formstrs = renderEFormMap(eformmap);
      this.aiText = text + formstrs;
      this.images = images;
      this.files = files;
    },
    async CopyAttachmentsToClip() {
      const text = this.images.map((v)=>`![${v.name}](${v.url})`).join('\n') + this.files.map((v)=>`[${v.name}](${v.url})`).join('\n');
      try {
        if (navigator.clipboard) {
          await navigator.clipboard.writeText(text);
        }
      } catch (err) {
        console.error('复制失败:', err);
        return false;
      }
      this.Success('复制成功');
      return true;
    },
    async CopyToClip() {
      const text = this.aiText || '';
      try {
        if (navigator.clipboard) {
          await navigator.clipboard.writeText(text);
        } else {
          const textarea = document.createElement('textarea');
          textarea.value = text;
          document.body.appendChild(textarea);
          textarea.select();
          const successful = document.execCommand('copy');
          if (!successful) {
            throw new Error('复制失败');
          }
          console.log(this.Success);

          document.body.removeChild(textarea);
        }
        this.Success('复制成功');
        return true;
      } catch (err) {
        console.error('复制失败:', err);
        return false;
      }
    },
    chat() {
      this.$ai.post('assistants/asst_7zEHmB2fxAgcP67FLe1M5R29/threads', {
        messages: [{role: 'user', content: '如何创建一个30层的直跑楼梯'}],
      }).then((res)=>{
        this.run = res.data.data;
        if (this.run.status !== 'complete') {
          setTimeout(()=>{
            this.Refresh();
          }, 1000);
        }
      });
    },
    RefreshSteps() {
      for (let i=0; i<this.steps.length; i++) {
        const step = this.steps[i];
        if (step.status == 'in_progress') {
          step.content = 'Answer:';
          this.RefreshStep(i);
        }
      }
    },
    RefreshStep(i) {
      const step = this.steps[i];
      this.$ai.get(`runs/${this.run.id}/steps/${step.id}?thread_id=${this.run.thread_id}`, {responseType: 'stream'}).then((response)=>{
        if (response && typeof response.pipe === 'function') {
          response.on('end', () => {
            console.log('end');
          });

          response.on('data', (chunk) => {
            console.log('data:', chunk.toString('utf-8'));
          });
        }
      });
    },
    RefreshMessage(message_id) {
      this.messages[message_id] = {content: ''};
      this.$ai.get(`threads/${this.run.thread_id}/message/${message_id}`, {responseType: 'stream', stream: true}).then((stream)=>{
        if (stream && stream.data) {
          stream.data.on('end', ()=>{
            console.log('end');
          });
          stream.data.on('data', (chunk)=>{
            this.messages[message_id].content += chunk.toString('utf-8');
            console.log('text:', chunk.toString('utf-8'));
          });
        }
      });
    },
    Refresh() {
      if (this.run && this.run.id) {
        this.$ai.get(`runs/${this.run.id}?thread_id=${this.run.thread_id}`).then((res)=>{
          const run = res.data.data;
          this.run.status = run.status;
          if (run.steps) {
            this.steps = run.steps;
          }
          if (this.run.status == 'queue') {
            setTimeout(()=>{
              this.Refresh();
            }, 1000);
          } else if (this.run.status == 'in_progress') {
            this.RefreshSteps();
          }
        });
      }
    },
    __afterRestorePageState() {
      // 旧版 pageState 存的是 freeDate 数组，迁移为 freeDateStart / freeDateEnd
      try {
        const raw = localStorage.getItem(this.pageStateKey);
        if (raw) {
          const state = JSON.parse(raw);
          if (Array.isArray(state.freeDate) && state.freeDate.length >= 2 && state.freeDateStart === undefined && state.freeDateEnd === undefined) {
            this.freeDateStart = moment(state.freeDate[0]).isValid() ? moment(state.freeDate[0]).format('YYYY-MM-DD HH:mm:ss') : this.freeDateStart;
            this.freeDateEnd = moment(state.freeDate[1]).isValid() ? moment(state.freeDate[1]).format('YYYY-MM-DD HH:mm:ss') : this.freeDateEnd;
          }
        }
      } catch (e) {/* ignore */}
      // 恢复状态后，如果项目列表已加载，确保 project_id 有效
      if (this.projects.length > 0 && this.project_id) {
        const project = this.projects.find((p) => p.id === this.project_id);
        if (!project) {
          // 如果保存的项目ID不存在，使用第一个项目
          this.project_id = this.projects[0].id;
        }
      }
      if (!this.platform) {
        this.platform = this.platforms[0].key;
      }

      if (!this.type) {
        this.type = this.types[0].key;
      }
      // 注意：getProjectData 会在 getProjects 完成后调用，避免重复调用
    },
  },
};
</script>

<style>
.image-container{
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 5px;
  width: 200px;
  height: 170px;
}
.image-container img{
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.image-label{
  font-size: 12px;
  color: #666;
  text-align: center;
}

</style>
